// Duke Skins Configuration
// Centralized configuration for all duke skin images
// Used by both Piece.jsx (rendering) and SettingsModal.jsx (UI selection)

// Duke skin image URLs - Object format for Piece.jsx rendering
export const DUKE_SKIN_IMAGES = {
  // === CLASSIC SHIELDS ===
  default: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/ykkqsx5j_hsik.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/qpjczey3_fight%20to%20be%20king.png'
  },
  // === METALLIC SHIELDS ===
  gold: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/d0wocpko_gik.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/k5jrfift_gftbk.png'
  },
  goldCrown: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/ykkqsx5j_hsik.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/4tkuk7qm_hsftbk.png'
  },
  lightGold: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/c81a50xs_inkinglightgold%20%2890%29.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/2r1gmm0k_darka%20metallic%20shield%20wi.png'
  },
  darkGold: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/6kve2rwu_darkgoldik%29.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/hbn9b8am_a%20metallic%20shield%20wi.png'
  },
  silver: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/4k3ey8zn_cartoongray%20%2892%29.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/i4r9dw38_download%20%2839%29.png'
  },
  silverOrnate: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/nchkvrk4_darksilverdik%29.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/69m8jvy3_download%20%28392%29.pngsilver.png'
  },
  platinum: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/4op3ks5r_A%20stylized%20metallic%20.pngii.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/wweu0hqe_lightsilver.png'
  },
  whiteGoldBase: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/c99lwa0n_darksilverandgdik%29.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/aj2dua7a_stylized%20emblem%20with.pngjjj.png'
  },
  // === COLOR SHIELDS ===
  purple: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/oqv5rbbp_purple.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/5vsqso2n_download%20%2833%29.png'
  },
  purpleVelvet: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/it7tfxbl_purple%20%2894%29.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/qzh7lni9_velvet.png'
  },
  blue: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/qf1wq9yp_blue.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/sdokjius_blue%20f.png'
  },
  blueCrown: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/2krbchf6_instantkingblue1.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/2of4x8jz_silverblue.png'
  },
  royalBlue: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/33wwk9ji_instantkingblue.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/ouq58as1_fight%20to%20be%20king%20blue.png'
  },
  navyBlue: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/z6yxpyvt_download%20%2829%29.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/yac957jd_bkik.png'
  },
  emerald: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/azkzagg2_greenishik.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/s3kyqngm_download%20%2832%29.png'
  },
  crimson: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/27sn2a4c_stylized%20emblem%20feat.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/mujhpnv2_redgcrown.png'
  },
  ruby: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/kww1y6vw_stylized%20emblem%20feat.2png.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/zslybpol_mred.png'
  },
  // === WHITE SHIELDS ===
  white: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/bv0igntc_whity.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/z1xmdc7j_Edit%20the%20uploaded%20em.png'
  },
  whiteSpartan: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/bv0igntc_whity.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/z1xmdc7j_Edit%20the%20uploaded%20em.png'
  },
  whiteEagle: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/o0aqzgyc_make%20the%20piece%20white.pngbird.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/cb304wq0_fight%20to%20be%20king%20white.png'
  },
  whiteMarble: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/kqez8jtq_dukewhite%20veriations.ikpng.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/cux53x1a_whitduke%20veriationsftbk.png'
  },
  whiteOutline: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/bv0igntc_whity.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/szz5jy9a_download%20%2828%29.png'
  },
  // === BLACK/DARK SHIELDS ===
  dark: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/qk7z6mvp_blaskishik%20%2891%29.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/4qn3t1ei_black%20f.png'
  },
  darkSteel: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/ye4svniw_download%20blik%29.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/f236y4kc_fighttbk.png'
  },
  blackCrown: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/mepsq01l_stylized%20black%20shiel.pngss.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/ql3t3yjw_Edit%20the%20uploaded%20em.pngihoih.png'
  },
  blackEagle: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/ibrgsxfd_make%20the%20piece%20black.pngbirdsheild.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/dpqme0i6_fight%20to%20be%20king%20blk.png'
  },
  blackMarble: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/64ovbf9h_dukeblack%20veriations.ikpng.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/ejbwx5a1_blackduke%20veriationsftbk.png'
  },
  charcoal: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/6ec90osu_the%20Instant%20K.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/4qn3t1ei_black%20f.png'
  },
  // === B&W SHIELDS ===
  bwMinimalist: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/y1cyinuk_instantkingblkandwhite.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/f0udzmkx_fight%20to%20be%20king%20blkandwhite.png'
  },
  bwDark: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/65lw0b5y_whity.blackpng.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/xe76k5jw_black%20f.png'
  },
  // === VINTAGE MEDIEVAL ===
  vintageMedieval: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/xyixsxig_instant%20king.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/gfuwql74_fight%20be%20be%20king2.png'
  },
  // === COLOSSAL EPIC ===
  colossalWhite: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/uhespnyg_super%20instant%20king%20White.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/mutzvi36_super%20fight%20to%20be%20king%20White.png'
  },
  colossalBronze: {
    instant_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/xm874g2x_super%20instant%20king%20Bronze.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_84991c84-6d47-47e1-b8cf-3698176afa48/artifacts/n1qlkq9x_super%20fight%20to%20be%20king%20Bronze.png'
  },
  // === GEMSTONE DUKES ===
  amethystPurple: {
    instant_king: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/6arok9cs_instantkingpurple.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/pk9rts0j_fighttobekingpurple.png'
  },
  sapphireBlue: {
    instant_king: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/04mj6ako_instantkingpsapphireblue.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/f977uxml_fighttobekingpsapphireblue.png'
  },
  // === KINGDOM DUKES ===
  stoneSand: {
    instant_king: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/kjmmcu12_sandinstantking.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/ifvfu1a5_sandarmoredfighttobekingduke.png'
  },
  woodlinWarriors: {
    instant_king: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/vfmc1g2g_woodleninstantking.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_chess-customizer/artifacts/xaa7wwll_woodlenfighttobekingarmored.png'
  },
  // === OUTLINED CROWN SHIELDS ===
  crownBlackOutline: {
    instant_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/3bk2hzmq_add%20a%20thick%20black%20ou.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/fd6i2v14_download2%20%2824%29.png'
  },
  crownWhiteOutline: {
    instant_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/afv85ihc_add%20a%20thick%20blackwhite%20ou.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/io3s434i_download%20%2824%29.png'
  },
  // === CLEAR CRYSTAL DUKES ===
  clearWhite: {
    instant_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/tba358ff_intstantkingwhiteclear.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/hdulhyc9_redid%20a%20thick%20fight2bekingwhiteii%20ou.png'
  },
  clearBlack: {
    instant_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/gxurjhg8_intstantkingblackclear.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/hhdtblp6_blackadd%20a%20thick%20fight2bekingwhiteii%20ou.png'
  },
  // === ENHANCED CLARITY DUKES ===
  enhancedClarity: {
    instant_king: 'https://customer-assets.emergentagent.com/job_chessskin-sync/artifacts/2jazd99x_enhance%20the%20clarity1.%20.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/l3j8qfub_ftbkingenhance%20the%20clarity%20.png'
  },
  enhancedClarityBlack: {
    instant_king: 'https://customer-assets.emergentagent.com/job_chessskin-sync/artifacts/ciwwt05t_instantkingblkenhance%20the%20clarity1%20.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/8k2r4do7_fighttobekingblkenhance%20the%20clarity%20.png'
  },
  // === CROSSED SWORDS DUKES ===
  swordsGray: {
    instant_king: 'https://customer-assets.emergentagent.com/job_chessskin-sync/artifacts/zgduzmrt_instantkinggrey%2825%29.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_chessskin-sync/artifacts/huulan1c_grayfighttobekingagain%29.png'
  },
  swordsBlack: {
    instant_king: 'https://customer-assets.emergentagent.com/job_chessskin-sync/artifacts/dj674ae4_instantkingblack%2825%29.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_chessskin-sync/artifacts/h9f09zrd_fighttobekingagain%29.png'
  },
  // === THICK OUTLINE DUKES ===
  thickOutlineWhite: {
    instant_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/xz6swibj_add%20a%20thick%20whiteii%20ou.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/hdulhyc9_redid%20a%20thick%20fight2bekingwhiteii%20ou.png'
  },
  thickOutlineBlack: {
    instant_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/hqy6nxra_instantking%20thick%20blackoutline%29.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/hhdtblp6_blackadd%20a%20thick%20fight2bekingwhiteii%20ou.png'
  },
  // === 3D PREMIUM DUKE SETS ===
  gold3D: {
    instant_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/ajlr3nf6_intstantkingclear3d.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/5ix88oin_fighttobekingclear3d.png'
  },
  neonGreen3D: {
    instant_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/efm8xg6h_intstantkingblackclea3d2greenr.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/g0yimnkl_fighttobekingblackcleargreen33d.png'
  },
  purpleNeon3D: {
    instant_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/mwjd7aid_intstantkingblackclea3d2purpler.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/retx1oog_fighttobekingblackclearpurple3d.png'
  },
  silver3D: {
    instant_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/unp0fjnx_intstantkingclear3d2.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/qex90hgs_fighttobekingclear3d2.png'
  },
  stealthBlack3D: {
    instant_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/z3gyehwc_intstantkingblackclea3d2r.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/ghbtioxp_fighttobekingblackclear3d.png'
  },
  // === FLAT CLEAR DUKE SETS ===
  clearWhiteFlat: {
    instant_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/tba358ff_intstantkingwhiteclear.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/pumihvsb_fighttobekingwhitclear.png'
  },
  clearBlackFlat: {
    instant_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/gxurjhg8_intstantkingblackclear.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_d8a577a5-4bac-4edb-8bcb-4701201421b8/artifacts/8qamk40q_fighttobekingblackclear.png'
  },
  // === COLOR-ADAPTIVE DUKE PIECES (High-detail grayscale for perfect color tinting) ===
  spartanShield: {
    instant_king: 'https://customer-assets.emergentagent.com/job_679752e6-b6cb-4a15-a6c6-b1acbe365a8d/artifacts/mol3zw6o_Double%20crown%20shield2%20.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_679752e6-b6cb-4a15-a6c6-b1acbe365a8d/artifacts/xayajrfx_Spartan%20shield%20chess1.png'
  },
  crownShield: {
    instant_king: 'https://customer-assets.emergentagent.com/job_679752e6-b6cb-4a15-a6c6-b1acbe365a8d/artifacts/mol3zw6o_Double%20crown%20shield2%20.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_679752e6-b6cb-4a15-a6c6-b1acbe365a8d/artifacts/xayajrfx_Spartan%20shield%20chess1.png'
  },
  // === FLAME SHIELD DUKES (Epic flame-wrapped shields) ===
  flameWarrior: {
    instant_king: 'https://customer-assets.emergentagent.com/job_679752e6-b6cb-4a15-a6c6-b1acbe365a8d/artifacts/cjpo0xnm_ftbk1.7png.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_679752e6-b6cb-4a15-a6c6-b1acbe365a8d/artifacts/cjpo0xnm_ftbk1.7png.png'
  },
  flameCrown: {
    instant_king: 'https://customer-assets.emergentagent.com/job_679752e6-b6cb-4a15-a6c6-b1acbe365a8d/artifacts/jhdhugk9_inking.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_679752e6-b6cb-4a15-a6c6-b1acbe365a8d/artifacts/jhdhugk9_inking.png'
  },
  // === FLAME SHIELD V2 (Line-art style with more detail) ===
  flameWarriorV2: {
    instant_king: 'https://customer-assets.emergentagent.com/job_679752e6-b6cb-4a15-a6c6-b1acbe365a8d/artifacts/khb146kf_ftbk%20newvpng.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_679752e6-b6cb-4a15-a6c6-b1acbe365a8d/artifacts/khb146kf_ftbk%20newvpng.png'
  },
  flameCrownV2: {
    instant_king: 'https://customer-assets.emergentagent.com/job_679752e6-b6cb-4a15-a6c6-b1acbe365a8d/artifacts/shqukg8t_inkingnewv.png',
    fight_to_be_king: 'https://customer-assets.emergentagent.com/job_679752e6-b6cb-4a15-a6c6-b1acbe365a8d/artifacts/shqukg8t_inkingnewv.png'
  }
};

// Helper function to get duke image
export const getDukeImage = (skinId, embodiment) => {
  const skin = DUKE_SKIN_IMAGES[skinId] || DUKE_SKIN_IMAGES.default;
  // Pro modes (fight_to_be_king_pro_1 / pro_2) share the Fight to be King Duke art.
  const isFightToBeKing = typeof embodiment === 'string' && embodiment.startsWith('fight_to_be_king');
  return isFightToBeKing ? skin.fight_to_be_king : skin.instant_king;
};

// Duke Skins UI Array - Used for settings selector with categories and names
// Category: 'white' = Light skins, 'black' = Dark skins, 'neutral' = Works for both
export const DUKE_SKINS_UI = [
  // === RECOMMENDED FOR WHITE PIECES ===
  { id: 'silver', name: '⬜ Silver', category: 'white' },
  { id: 'white', name: '⬜ White Spartan', category: 'white' },
  { id: 'whiteEagle', name: '⬜ White Eagle', category: 'white' },
  { id: 'goldCrown', name: '⬜ Gold Crown', category: 'white' },
  { id: 'platinum', name: '⬜ Platinum', category: 'white' },
  { id: 'whiteGoldBase', name: '⬜ White Gold Base', category: 'white' },
  { id: 'whiteMarble', name: '⬜ White Marble Knight', category: 'white' },
  { id: 'lightGold', name: '⬜ Light Gold', category: 'white' },
  { id: 'silverOrnate', name: '⬜ Silver Ornate', category: 'white' },
  { id: 'whiteOutline', name: '⬜ White Outline', category: 'white' },
  { id: 'colossalWhite', name: '🏛️ Colossal White', category: 'white' },
  { id: 'crownWhiteOutline', name: '⬜ Crown White Outline', category: 'white' },
  { id: 'clearWhite', name: '⚪ Clear White', category: 'white' },
  { id: 'enhancedClarity', name: '✨ Enhanced Clarity', category: 'neutral' },
  { id: 'thickOutlineWhite', name: '⬜ Thick Outline White', category: 'white' },
  { id: 'gold3D', name: '🌟 Gold 3D Premium', category: 'neutral' },
  { id: 'silver3D', name: '⬜ Silver 3D Premium', category: 'white' },
  { id: 'clearWhiteFlat', name: '⚪ Clear White Flat', category: 'white' },
  { id: 'swordsGray', name: '⚔️ Swords Gray', category: 'white' },
  // === RECOMMENDED FOR BLACK PIECES ===
  { id: 'dark', name: '⬛ Dark Steel', category: 'black' },
  { id: 'darkSteel', name: '⬛ Dark Steel 3D', category: 'black' },
  { id: 'purple', name: '⬛ Purple', category: 'black' },
  { id: 'purpleVelvet', name: '⬛ Purple Velvet', category: 'black' },
  { id: 'blue', name: '⬛ Blue', category: 'black' },
  { id: 'blueCrown', name: '⬛ Blue Crown', category: 'black' },
  { id: 'royalBlue', name: '⬛ Royal Blue', category: 'black' },
  { id: 'navyBlue', name: '⬛ Navy Blue', category: 'black' },
  { id: 'crimson', name: '⬛ Crimson', category: 'black' },
  { id: 'ruby', name: '⬛ Ruby', category: 'black' },
  { id: 'blackCrown', name: '⬛ Black Crown', category: 'black' },
  { id: 'blackEagle', name: '⬛ Black Eagle', category: 'black' },
  { id: 'blackMarble', name: '⬛ Black Marble Knight', category: 'black' },
  { id: 'charcoal', name: '⬛ Charcoal', category: 'black' },
  { id: 'darkGold', name: '⬛ Dark Gold', category: 'black' },
  { id: 'colossalBronze', name: '🏛️ Colossal Bronze', category: 'black' },
  { id: 'crownBlackOutline', name: '⬛ Crown Black Outline', category: 'black' },
  { id: 'clearBlack', name: '⚫ Clear Black', category: 'black' },
  { id: 'enhancedClarityBlack', name: '✨ Enhanced Clarity Dark', category: 'black' },
  { id: 'thickOutlineBlack', name: '⬛ Thick Outline Black', category: 'black' },
  { id: 'stealthBlack3D', name: '⬛ Stealth Black 3D', category: 'black' },
  { id: 'neonGreen3D', name: '💚 Neon Green 3D', category: 'black' },
  { id: 'purpleNeon3D', name: '💜 Purple Neon 3D', category: 'black' },
  { id: 'clearBlackFlat', name: '⚫ Clear Black Flat', category: 'black' },
  { id: 'swordsBlack', name: '⚔️ Swords Black', category: 'black' },
  // === NEUTRAL - WORKS FOR BOTH ===
  { id: 'default', name: '🎖️ Classic', category: 'neutral' },
  { id: 'gold', name: '🥇 Gold', category: 'neutral' },
  { id: 'emerald', name: '💚 Emerald', category: 'neutral' },
  { id: 'vintageMedieval', name: '📜 Vintage Medieval', category: 'neutral' },
  { id: 'bwMinimalist', name: '⬜ B&W Minimalist', category: 'neutral' },
  { id: 'bwDark', name: '⬛ B&W Dark', category: 'neutral' },
  // === GEMSTONE DUKES ===
  { id: 'amethystPurple', name: '💎 Amethyst Purple', category: 'neutral' },
  { id: 'sapphireBlue', name: '💙 Sapphire Blue', category: 'neutral' },
  // === KINGDOM DUKES ===
  { id: 'stoneSand', name: '🏜️ Stone & Sand', category: 'neutral' },
  { id: 'woodlinWarriors', name: '🌲 Woodlin Warriors', category: 'neutral' },
  // === NEW PURCHASABLE DUKE PIECES ===
  { id: 'spartanShield', name: '⚔️ Spartan Shield', category: 'neutral' },
  { id: 'crownShield', name: '👑 Crown Shield', category: 'neutral' },
  // === FLAME SHIELD DUKES ===
  { id: 'flameWarrior', name: '🔥 Flame Warrior', category: 'neutral' },
  { id: 'flameCrown', name: '🔥 Flame Crown', category: 'neutral' },
  // === FLAME SHIELD V2 ===
  { id: 'flameWarriorV2', name: '🔥 Flame Warrior V2', category: 'neutral' },
  { id: 'flameCrownV2', name: '🔥 Flame Crown V2', category: 'neutral' }
];

// Get duke skins filtered by category
export const getDukeSkinsByCategory = (category) => {
  if (category === 'all') return DUKE_SKINS_UI;
  return DUKE_SKINS_UI.filter(skin => skin.category === category);
};
